<template>
    <cus-dialog
        :title="$tran('Change Password')"
        :visible="passwordVisitable"
        :close="closeDialog"
        :showClose="false">
        <div class="updateDialog-content">
            <div class="base-flex relative" style="width:0px;height:0px;overflow: hidden;">
                <cus-input :placeholder="$tran('Enter the original password')" class="base-flex-grow1" size="big" password :type="oldpasswordVisable ? 'password' : 'text'" autocomplete="new-password" :autocomplete="'new-password'"/>
            </div>
            <div class="base-flex relative">
                <span class="base-bText14">{{ $tran('Old Password') }}</span>
                <cus-input v-model="passwordObj.password" :placeholder="$tran('Enter the original password')" class="base-flex-grow1" size="big" password :type="oldpasswordVisable ? 'password' : 'text'" autocomplete="new-password" :autocomplete="'new-password'">
                    <i @click="oldpasswordVisable = !oldpasswordVisable" slot="suffix" :class="oldpasswordVisable ? 'el-icon-lock' : 'el-icon-unlock'"></i>
                </cus-input>
            </div>
            <div class="base-flex relative" style="margin-top:30px;">
                <span class="base-bText14">{{ $tran('New Password') }}</span>
                <cus-input v-model="passwordObj.newPassword" :placeholder="$tran('Enter a new password')" class="base-flex-grow1" size="big" password :type="passwordDisplay ? 'password' : 'text'">
                    <i @click="passwordDisplay = !passwordDisplay" slot="suffix" :class="passwordDisplay ? 'el-icon-lock' : 'el-icon-unlock'"></i>
                </cus-input>

                <div class="resetpassword-tip">{{$tran("Enter a new password。It must include at least three of the following：uppercase letters，lowercase letters，numbers，and special characters")}}</div>
            </div>
            <div class="base-flex relative">
                <span class="base-bText14">{{ $tran('Confirm Password') }}</span>
                <cus-input v-model="passwordObj.newConfirmPassword" :placeholder="$tran('Enter the new password again')" class="base-flex-grow1" size="big" password :type="passwordDisplay2 ? 'password' : 'text'">
                    <i @click="passwordDisplay2 = !passwordDisplay2" slot="suffix" :class="passwordDisplay2 ? 'el-icon-lock' : 'el-icon-unlock'"></i>
                </cus-input>
                <div class="resetpassword-tip">{{$tran("This must match the new password above")}}</div>
            </div>
        </div>
        <div class="updateDialog-footer">
        <cus-button @click="gotoLogin" type="confirm">{{ $tran('Cancel') }}</cus-button>
            <cus-button @click="confirmUpdate" type="confirm">{{ $tran('Confirm') }}</cus-button>
        </div>
    </cus-dialog>
</template>

<script>
import store from '@/store';
import { postRequest, putRequest } from '@/api/api';
export default {
    props: {
        isShowCancel: {
            default: false,
            type: Boolean
        }
    },
    name:"UpdateDialog",
    data() {
        return {
            oldpasswordVisable:true,
            passwordVisitable: false, // Default does not display password change pop-up window
            passwordDisplay:true,
            passwordDisplay2:true,
            passwordObj: {
                password: null,
                newPassword: null,
                newConfirmPassword: null
            },
        }
    },
    computed: {
    },
    watch: {
        passwordVisitable(newV) {
            store.commit('updateIsLoginDialogShow', newV);
        },
        isShowCancel(newV) {
            if(!newV) {
                this.closeDialog();
            }
        }
    },
    methods: {
        showDialog() {
            if(store.getters.isFirstLogin) {
                this.passwordVisitable = true;
            }
        },
        closeDialog() {
            this.passwordVisitable = false;
            this.passwordObj = {
                password: null,
                newPassword: null,
                newConfirmPassword: null
            };
            let temLoginInfo = { ...store.state.loginInfo };
            temLoginInfo.user = { ...((temLoginInfo && temLoginInfo.user) || {}), resetPasswordFlag: 0 }
            store.commit('updateLoginInfo', temLoginInfo);
        },
        confirmUpdate() {
            if(!this.passwordObj.password && this.passwordObj.password !== 0) {
                this.$message.info('Please Enter your x', 'Old Password');
                return;
            }
            if(!this.passwordObj.newPassword && this.passwordObj.newPassword !== 0) {
                this.$message.info('Please Enter your x', 'New Password');
                return;
            }
            if(!this.passwordObj.newConfirmPassword && this.passwordObj.newConfirmPassword !== 0) {
                this.$message.info('Please Enter your x', 'Confirm Password');
                return;
            }
            if(this.passwordObj.newConfirmPassword !== this.passwordObj.newPassword) {
                this.$message.info('The two passwords entered do not match');
                return;
            }
            
            putRequest('/system/user/updatePassword', { ...this.passwordObj }).then(res => {
                if(res && res.code === 200) {
                    window.removeCookie("pd");
                    window.PasswordLongTip.hide();
                    this.$message.success(res.msg || 'Password changed successfully');
                    this.closeDialog();
                    window.location.reload();
                }
            })
        },
        gotoLogin(){

            window.removeCookie("pd");
            window.removeCookie('token');
            localStorage.removeItem("isGetToken") 
            window.PasswordLongTip.hide();
            this.closeDialog();
             window.location.reload();
            // postRequest('/system/auth/logout').then(res => {
            //     if(res && res.code === 200) {
            //         this.$message.success(res.msg || 'Exited successfully');
            //         window.removeCookie('token');
            //         localStorage.removeItem("isGetToken") 
            //          window.removeCookie("pd");
            //          window.PasswordLongTip.hide();
            //           this.closeDialog();
            //          this.$router.push('/login');
            //     }
            // })

        }
    },
    created() {
    },
    mounted(){
        try
        {
            if(!!window.getCookie("pd"))
            {
                window.PasswordLongTip.show(this.$tran('Please copy this password into the input box: ') + window.getCookie("pd"));
                /*
                getRequest('/system/auth/auth').then(res => {
                    if(res && res.code === 200 && res.data) {
                    window.PasswordLongTip.show(this.$tran('Please copy this password into the input box: ') + res.data);
                    };
                })
                */
            }
        }
        catch(e){}
    }
}
</script>

<style lang="scss" scoped>
.updateDialog-content {
    padding: 20px;
    padding-bottom: 40px;
    >div {
        &:not(:first-of-type) {
            margin-top: 42px;
        }
        >span {
            min-width: 160px;
            text-align: right;
        }
        >div {
            margin-left: 30px;
        }
    }
    .relative{
        position: relative;
    }
    .resetpassword-tip{
        position: absolute;
        left:160px;
        top:40px;
        color:#555;
        font-size:12px;
    }
}
.updateDialog-footer {
    border-top: 1px solid #CBD5E1;
    padding: 20px 24px;
    height: 81px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
</style>